export function nextFrame() {
  return new Promise((resolve) => requestAnimationFrame(resolve))
}

export function nextIdle() {
  return new Promise((resolve) => (window.requestIdleCallback || setTimeout)(resolve))
}

export function delay(ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function debounce(fn, ms = 0) {
  let timeout
  return (...args) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => fn(...args), ms)
  }
}

export function debounceAnimationFrame(fn) {
  let frame
  return (...args) => {
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(() => fn(...args))
  }
}
